<div
  [class]="'animated fadeIn fade-in ' + andClass"
  [ngClass]="{
    'card-content': type === 'table',
    'card-body': type === '' || !type,
    'card-list-item': type === 'list',
  }"
  [class.no-padding]="noPadding">
  <!--  TODO: deprecate fadeIn for fade-in-->
  <ng-content></ng-content>
</div>
